// extracted by mini-css-extract-plugin
module.exports = {"vPrimary1":"#733499","arrow":"MessengerStatusArrow_arrow__3SRao"};